const PUBLIC_STUN_SERVER = 'stun:stun.l.google.com:19302'
const DELAY_BEFORE_CLOSE_CONNECTION = 1000

let isVPN: boolean

export const getCacheVPN = () => isVPN
export const setCacheVPN = (value: boolean) => isVPN = value

export async function detectVPN(currentIp: string) {
  const rtcPeerConnection = new RTCPeerConnection({
    iceServers: [{ urls: PUBLIC_STUN_SERVER }],
  })

  const ipAddresses = new Set()

  rtcPeerConnection.onicecandidate = (event) => {
    if (event.candidate) {
      const candidate = event.candidate.candidate
      const ipRegex = /([0-9]{1,3}\.){3}[0-9]{1,3}/
      const ip = candidate.match(ipRegex)?.[0]
      if (ip) ipAddresses.add(ip)
    }
  }

  rtcPeerConnection.createDataChannel('')

  try {
    const offer = await rtcPeerConnection.createOffer()
    await rtcPeerConnection.setLocalDescription(offer)
  } catch (error) {
    console.error(error)
    // console.error("Помилка створення WebRTC-з'єднання:", error)
  }

  await new Promise((resolve) => setTimeout(resolve, DELAY_BEFORE_CLOSE_CONNECTION))

  rtcPeerConnection.close()

  const isVPN = !Array.from(ipAddresses).includes(currentIp)
  setCacheVPN(isVPN)
  return isVPN
}
